<template lang='pug'>
  router-view
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue